import { useState } from "react";
import { useMutation } from "@apollo/client/react";
import { DELETE_TENANT } from "@/hooks";
import type { DeleteTenantMutation } from "@/types/graphql";

type DeleteTenantResponse = {
  deleteTenant: DeleteTenantMutation;
};

export const useDeleteTenant = (
  onCompleted: () => void = () => {},
  onError: (_error: string) => void = (_error) => {},
) => {
  const [success, setSuccess] = useState(false);

  const [deleteTenant, { loading }] = useMutation<DeleteTenantResponse>(
    DELETE_TENANT,
    {
      onCompleted: (response) => {
        if (response.deleteTenant?.success) {
          setSuccess(true);
          setTimeout(() => {
            setSuccess(false);
          }, 5000);
          onCompleted();
        } else {
          setSuccess(false);
        }
      },
      onError: ({ message }) => {
        setSuccess(false);
        onError(message);
      },
    },
  );

  return {
    deleteTenant,
    loading,
    success,
  };
};
